// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"bcb2ff9e","267":"909df8da","419":"b14558b4","529":"912da1da"}[chunkId] + ".chunk.js";
};